import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

export class BienvenidaService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getBienvenida() {
    return this.http.get(`${this.API_URI}/bienvenida`);
  }

}
